// Providers: QueryClient, Router, i18n, Theme, Toaster (spec 10 § 9). Tokens first so every component sees them.
import '@orca/tokens/orca.css'
import '@orca/tokens/kit.css'
import 'sonner/dist/styles.css' // sonner's own runtime <style> is dropped at build (vite.config.ts): the CSP refuses it
import './styles/app.css'
import './shared/motion/motion.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ReauthSheet } from './features/reauth/ReauthSheet'
import { installReauthHook } from './features/reauth/reauth'
import { router } from './router'
import { installAccessHooks } from './shared/access/access'
import './shared/i18n/i18n'
import { applyKeptAppearance } from './shared/appearance/appearance'
import { queryClient } from './shared/query/queryClient'
import { installRealtime } from './shared/realtime/connection'
import { installStaleBundleReload } from './shared/release/staleBundle'
import { installSession } from './shared/session/session'
import { ThemedToaster, ThemeProvider } from './shared/theme/ThemeProvider'
import { applyTheme, readTheme } from './shared/theme/theme'

installStaleBundleReload()
installSession(router) // a 401 ends the session once and routes to sign-in; reads the CSRF cookie on first load
installAccessHooks(queryClient) // a refusal that says the access changed refetches /me/access
installReauthHook() // a query refused with reauthentication_required raises the ReauthSheet
installRealtime(queryClient) // one socket per tab while /me answers an account: events invalidate the screens' queries
applyKeptAppearance() // reduced motion, kept the same way
applyTheme(readTheme()) // before the first render; the CSP allows no inline script in index.html to do it earlier

const root = document.getElementById('root')
if (!root) throw new Error('index.html has no #root')

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReauthSheet />
        <ThemedToaster />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
